import { withStyles } from "@material-ui/core/styles";
import { Button, Grid, Select, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import styled from "styled-components";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export const DataFound = styled.div`
  text-align: center;
  background: rgba(190, 137, 118, 0.12);
  border: 1px solid rgba(190, 137, 118, 0.39);
  width: max-content;
  margin: auto;
  font-family: system-ui;
  padding: 5px 10px;
  border-radius: 5px;
  color: rgb(190, 137, 118);
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: column;
`;

export const ButtonLink = styled.button`
  background: rgb(190, 137, 118);
  padding: 12px 20px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  font-family: system-ui;
  border: none;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BlackTooltip = withStyles({
  tooltip: {
    color: "#fff",
    backgroundColor: "#000 !important",
    fontSize: "0.75rem !important",
    textAlign: "center",
  },
  arrow: {
    color: "#000 !important",
  },
})(Tooltip);

export const CustomerTooltip = withStyles({
  tooltip: {
    color: "#000",
    backgroundColor: "#e9d2c9 !important",
    fontSize: "0.75rem",
    padding: "7px 15px",
  },
  arrow: {
    color: "#e9d2c9 !important",
  },
})(Tooltip);

export const Onboarding = styled.span`
  font-size: 12px;
  background-color: rgb(221, 246, 219);
  color: ${(props) =>
    props.status === "ONBOARDING" ? "rgb(68, 116, 11)" : "#0088ff"};
  padding: 4px 10px;
  border-radius: 50px;
  border: 1px solid;
`;

export const ColorPalette = styled.div`
  padding: 5px;
  margin-right: 5px;
  border-radius: 2px;
  margin-top: 1px;
  background: ${(props) =>
    props.status === "Inprogress"
      ? "#FFA318"
      : props.status === "Rejected"
      ? "red"
      : props.status === "Hold"
      ? "rgb(172, 141, 175)"
      : "#BE89764D"};
`;

export const ColorPaletteLetter = styled.span`
  font-family: system-ui;
`;

export const DashboardTableCell = styled.div`
  padding: 10px;
  border-radius: 5px;
  border: 0.978px solid #3631573d;
  background-color: ${(props) =>
    props.status === "ONBOARDING"
      ? "#be89764d"
      : props.status === "HOLDFORTHISMONTH"
      ? "rgb(172, 141, 175)"
      : "#3631570F"};
  color: ${(props) => (props.status === "HOLDFORTHISMONTH" ? "#fff" : "")};
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  width: fit-content;
  position: relative;
  width: 100%;
`;

export const ExportDataLabel = styled.div`
  display: flex;
  justify-content: center;
  font-size: 10px;
  margin-right: -5px;
  font-family: system-ui;
  font-weight: 500;
`;

export const ExportButton = styled(Button)`
  background-color: #be8976 !important;
  &:hover {
    background-color: #be8976 !important;
  }
  &:disabled {
    background-color: #ccc !important;
    color: #666 !important;
    cursor: not-allowed !important;
  }
`;

export const WorkPlace = styled(Box)`
  border: 1px solid rgba(54, 49, 87, 0.12);
  border-radius: 6px;
  background: #FFF;
  box-shadow: 0px 5.08601px 30.51603px 0px rgba(0, 0, 0, 0.10);
`;

export const TableTitleBar = styled(Grid)`
display:flex;
justify-content:space-between;
`;

export const TableFilterBar = styled(Grid)`
display:flex;
align-items:center;
`;

export const TableSearchFilter = styled(Grid)`
  flex-direction:column;
  width:100%;
`;

export const MonthFilter = styled(Select)`
  height:40px;
  font-weight:500;
  color: "rgb(86, 97, 102)";
  font-size: "14px";
`;

export const YearFilter = styled(Select)`
  height:40px;
  font-weight:500;
  color: "rgb(86, 97, 102)";
  font-size: "14px";
`;

export const StatusFilter = styled(Select)`
  height:40px;
  font-weight:500;
  color: "rgb(86, 97, 102)";
  font-size: "14px";
`;

export const CustomerDetailBar = styled(Grid)`
display:"flex";
height:70px;
`;

export const TitleBar = styled(Grid)`
display:"flex";
height:70px;
font-size:"14px";
`;

export const NotesBar = styled(Grid)`
display:"flex";
alignItems:"center";
width:"100%";
height:70px;
font-size:"14px";
`;

export const AssetList = styled(Grid)`
display:"flex";
height:70px;
font-size:"14px";
`;

export const UploadDropzone = styled.div`
  border: 1.5px dashed #363157;
  border-radius: 6px;
  padding: 1px;
  text-align: center;
  cursor: pointer;
  background-color: #f2f2f2;
  min-width: 60px;
  min-height: 50px;
  color: grey;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const UploadIconStyled = styled(CloudUploadIcon)`
  font-size: 1.5rem !important;
  color: #363157;
  margin-bottom: 4px;
`;
